module.exports = __webpack_public_path__ + "static/img/0.21f0835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/0.png
// module id = gWzU
// module chunks = 1